var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.01 31.6873H19.9767C19.8733 31.6873 9.53499 31.6673 6.92665 30.959C5.49236 30.5726 4.37224 29.4518 3.98665 28.0173C3.51762 25.3713 3.29112 22.6879 3.30999 20.0007C3.29787 17.309 3.53049 14.6218 4.00499 11.9723C4.40117 10.5365 5.51637 9.41057 6.94832 9.00065C9.48499 8.33398 19.5383 8.33398 19.965 8.33398H20C20.105 8.33398 30.47 8.35398 33.0517 9.06232C34.4829 9.45067 35.6008 10.5691 35.9883 12.0007C36.4723 14.6566 36.6994 17.3529 36.6667 20.0523C36.6783 22.7407 36.4452 25.4246 35.97 28.0707C35.5794 29.5034 34.4586 30.6217 33.025 31.009C30.4917 31.6807 20.4367 31.6873 20.01 31.6873ZM16.6767 15.009L16.6683 25.009L25.355 20.009L16.6767 15.009Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.c703ee7a02692feb831ca57576838d10.svg";
export { ForwardRef as ReactComponent };